"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeartFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.7 14.733a1.05 1.05 0 01-1.4 0l-.46-.409C2.72 10.668 0 8.254 0 5.302 0 2.889 1.932 1 4.4 1A4.85 4.85 0 018 2.63 4.846 4.846 0 0111.6 1C14.068 1 16 2.889 16 5.302c0 2.953-2.72 5.366-6.84 9.022l-.46.409z",
    clipRule: "evenodd"
  })))
});
HeartFilledIcon.displayName = 'HeartFilledIcon';
var _default = exports.default = HeartFilledIcon;